import { RefElement } from 'widgets/toolbox/RefElement';
import { TWidget } from 'widgets/Widget';
import { extractPath } from '../utils';

/**
 * @description BreadcrumbsTrack implementation
 * @param Widget Base widget for extending
 * @returns BreadcrumbsTrack class
 */
function BreadcrumbsTrackClassCreator(Widget: TWidget) {
    class BreadcrumbsTrack extends Widget {
        /**
         * Emits a click event with a specific event type and URL path
         *
         * @param elem - The element that was clicked
         */
        breadcrumbTrackLink(elem: RefElement<HTMLElement>) {
            const url = extractPath(elem.attr('href'));

            this.eventBus().emit('breadcrumb.click', url);
        }
    }

    return BreadcrumbsTrack;
}

export type TBreadcrumbsTrack = ReturnType<typeof BreadcrumbsTrackClassCreator>;

export type TBreadcrumbsTrackInstance = InstanceType<TBreadcrumbsTrack>;

export default BreadcrumbsTrackClassCreator;
